import { persistStore, autoRehydrate } from 'redux-persist-immutable';
import * as Immutable from 'immutable';
import localForage from 'localforage';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import jack from 'jack-logs';
import setupJack from '../lib/jack';
import checkCompatibility from '../lib/checkCompatibility';
import { setStateGetter } from '../lib/Airbrake';
import migrations from './migrations';
import reducers from './reducers';
import Background from '../workers/Background';
import logApplicationStart from '../lib/logApplicationStart';
import { removeByType } from './messages/systemMessages/actions';
import demoInitialState from './demo-mode-initial-state';

const { Map } = Immutable;

const actionContext = require.context('./', true, /actions\.js$/);
window.localForage = localForage;

function getAllActionsOfName(name) {
  return actionContext.keys().reduce((refreshers, key) => {
    const ctx = actionContext(key);
    if (ctx[name] instanceof Function) {
      refreshers.push(ctx[name]);
    }
    return refreshers;
  }, []);
}

function loadRefreshers() {
  return getAllActionsOfName('refresh');
}

function loadClearActions() {
  return getAllActionsOfName('clear');
}

function getRehydrate() {
  if (window.DEMO_MODE) {
    return s => s; // no-op enhancer
  }
  return autoRehydrate({ log: __DEV__ });
}

function getInitialState() {
  return window.DEMO_MODE ? demoInitialState : new Map();
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  process.env.NODE_ENV === 'development' ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    serialize: {
      immutable: Immutable,
    },
  })
  : compose;
/* eslint-enable no-underscore-dangle */

const store = createStore(reducers, getInitialState(), composeEnhancers(
  applyMiddleware(thunk),
  migrations,
  getRehydrate(),
));

export default store;

// TODO: I'm not super happy with this
export function clearStore() {
  const clearers = loadClearActions();
  clearers.forEach(clear => store.dispatch(clear()));
  hashHistory.push('/setup');
}

export const bg = new Background(store, loadRefreshers());

function getRouterState(state) {
  return state.get('routing').toJS();
}

const history = syncHistoryWithStore(hashHistory, store, {
  selectLocationState: getRouterState,
});

history.listen((location) => {
  if (location.pathname === '/timeclock') {
    if (!bg.isStarted) {
      bg.startPoll();
    }
  } else {
    bg.stopPoll(); // stop polling after we leave `/timeclock`
  }
});

store.dispatch({ type: 'PERSIST_START' });

checkCompatibility()
  .then(() => {
    if (window.DEMO_MODE) {
      bg.refreshNow();
      store.dispatch({ type: 'PERSIST_FINISH' });
      hashHistory.push('/timeclock');
    } else {
      // we can use persistance on this device/browser
      persistStore(store, {
        blacklist: ['currentUser', 'config'],
        storage: localForage,
      }, async () => {
        jack.dev.log('Successfully rehydrated the store');
        bg.refreshNow();
        logApplicationStart(store.getState());
        store.dispatch({ type: 'PERSIST_FINISH' });
        store.dispatch(removeByType('updateReady'));
        hashHistory.push('/timeclock');
      });
    }
  })
  .catch(() => {
    if (!window.DEMO_MODE) {
      /* eslint-disable no-alert */
      alert('Private/Incognito browsing means we can\'t save your staff list,'
        + ' so leaving this page will remove all the data from the site.');
      /* eslint-enable no-alert */
    }
    store.dispatch({ type: 'PERSIST_FINISH' });
    hashHistory.push('/timeclock');
  });

setupJack(store);
setStateGetter(store.getState);



// WEBPACK FOOTER //
// ./src/store/index.js